module.exports = __webpack_public_path__ + "static/memsource-click-allow-173f5ac1fc9521fde2b9475fe6d30c26.jpg";